import { memo } from "react";
import { POVSelectorButton } from "./povSelectorButton";
import { TenseSelectorButton } from "./tenseSelectorButton";

function SimplifiedTenseAndPOV({
  containerRef,
  pov,
  tense,
  handleManualTenseChange,
  handleManualPOVChange,
  handleCharacterSelectChange,
  oneOrManyCharacters,
  showLabel,
  showPOVLabel,
  showTenseLabel,
  className,
  collisionBoundarySelector,
}) {
  // Use separate props if provided, otherwise fall back to showLabel for backward compatibility
  const povLabelVisible = showPOVLabel !== undefined ? showPOVLabel : showLabel;
  const tenseLabelVisible = showTenseLabel !== undefined ? showTenseLabel : showLabel;

  return (
    <>
      <POVSelectorButton
        pov={pov}
        handleManualPOVChange={handleManualPOVChange}
        handleCharacterSelectChange={handleCharacterSelectChange}
        oneOrManyCharacters={oneOrManyCharacters}
        showLabel={povLabelVisible}
        collisionBoundarySelector={collisionBoundarySelector}
      />
      <TenseSelectorButton
        tense={tense}
        setTense={handleManualTenseChange}
        showLabel={tenseLabelVisible}
      />
    </>
  );
}

export default memo(SimplifiedTenseAndPOV);
